const SANITIZATION_PIPELINE = [
    removeControlCharacters,
    getLastPathSegment,
    replaceProblematicCharacters,
    emptyIfReservedForFilesystem,
];

const RESERVED_FILESYSTEM_BASENAMES = ['.', '..', '~'];
const CONTROL_CHAR_MAX = 31;
const DELETE_CHAR = 127;

export function sanitizeFilename(filename: string): string | undefined {
    const sanitized = SANITIZATION_PIPELINE.reduce(
        (accumulator, sanitize) => sanitize(accumulator),
        filename,
    );
    return sanitized || undefined;
}

function removeControlCharacters(filename: string): string {
    return filename
        .trim()
        .split('')
        .filter((char) => {
            const code = char.charCodeAt(0);
            return code > CONTROL_CHAR_MAX && code !== DELETE_CHAR;
        })
        .join('');
}

function getLastPathSegment(input: string): string {
    const segments = input.split(/[/\\]/);
    return segments[segments.length - 1] ?? '';
}

function emptyIfReservedForFilesystem(filename: string): string {
    return RESERVED_FILESYSTEM_BASENAMES.includes(filename) ? '' : filename;
}

function replaceProblematicCharacters(filename: string): string {
    return filename.replace(/[<>:"|?*]/g, '_');
}
